import { InfoIcon, MailIcon, MessageSquareIcon, Trash2Icon } from "lucide-react";
import { NavLink, useParams } from "react-router-dom";
import { SettingsLayout, SettingsNav, SettingsNavItem } from "@/components/ui/settings-layout";
import {
  CampaignInfoSection,
  EmailSection,
  MessagingSection,
  TechnicalSection,
} from "../settings";

const SECTIONS = [
  { key: "info", label: "Campaign Info", icon: InfoIcon },
  { key: "email", label: "Email", icon: MailIcon },
  { key: "messaging", label: "Messaging", icon: MessageSquareIcon },
  { key: "danger", label: "Danger & IDs", icon: Trash2Icon },
];

export default function SettingsTab() {
  const { section = "info" } = useParams<{ section: string }>();

  return (
    <SettingsLayout
      sectionKey={section}
      nav={
        <SettingsNav>
          {SECTIONS.map((s) => (
            <SettingsNavItem key={s.key} asChild active={section === s.key}>
              <NavLink to={`../${s.key}`}>
                <s.icon />
                {s.label}
              </NavLink>
            </SettingsNavItem>
          ))}
        </SettingsNav>
      }
    >
      {section === "info" && <CampaignInfoSection />}
      {section === "email" && <EmailSection />}
      {section === "messaging" && <MessagingSection />}
      {section === "danger" && <TechnicalSection />}
    </SettingsLayout>
  );
}
